import { FC } from 'react';
import { AnvaQuote } from '@flows/src/types/anva';
import { Box } from '@wegroup/design-system';
import useAnvaFlowProductSelectionStore from '@flows/src/store/zustand/flows-products/useAnvaFlowProductSelectionStore';
import AnvaProductCartWidgetItem from '@flows/src/components/flow-products/quotes/cart/AnvaProductCartWidgetItem';

interface Props {
  quotes: AnvaQuote[];
}

const AnvaProductCartWidgetItems: FC<Props> = ({ quotes }) => {
  const removeFromSelected = useAnvaFlowProductSelectionStore(
    (state) => state.removeFromSelected,
  );

  const handleRemove = (item: AnvaQuote) => {
    removeFromSelected(item);
  };

  return (
    <Box maxH="sm" overflowY="auto">
      <Box
        height={`${quotes.length * 50}px`}
        transition="0.2s"
        overflow="hidden"
      >
        {quotes.map((quote) => (
          <AnvaProductCartWidgetItem
            key={`${quote.id}-${quote.index}`}
            data={quote}
            onRemove={() => handleRemove(quote)}
          />
        ))}
      </Box>
    </Box>
  );
};

export default AnvaProductCartWidgetItems;
